/* Chart matching only. No arch diagnosis, inventory recommendation or cart persistence. */
(() => {
  'use strict';
  function range(value) {
    if (typeof value !== 'string') return null;
    const match = value.match(/^(\d+(?:\.5)?)\s*[–-]\s*(\d+(?:\.5)?)$/);
    if (!match) return null;
    const pair = [Number(match[1]), Number(match[2])];
    return pair[0] > 0 && pair[1] >= pair[0] && pair[1] <= 30 ? pair : null;
  }
  function readRows(data) {
    const guide = data?.sizeGuide;
    if (!Array.isArray(guide?.usShoeSizeMapping) || !Array.isArray(guide?.lengths)) return [];
    const expected = ['XS', 'S', 'M', 'L', 'XL'];
    if (guide.usShoeSizeMapping.length !== expected.length) return [];
    const rows = guide.usShoeSizeMapping.map((item, i) => {
      const length = guide.lengths.find(row => row?.size === item?.size);
      const men = range(item?.men), women = range(item?.women);
      if (item?.size !== expected[i] || !men || !women || !Number.isFinite(length?.lengthIn) || !Number.isFinite(length?.lengthCm) || length.lengthIn <= 0 || length.lengthCm <= 0) return null;
      return { size:item.size, men, women, menLabel:item.men, womenLabel:item.women, lengthIn:length.lengthIn, lengthCm:length.lengthCm };
    });
    return rows.every(Boolean) ? rows : [];
  }
  function choices(rows, system) {
    if (system !== 'men' && system !== 'women') return [];
    const values = new Set();
    rows.forEach(row => {
      const [min, max] = row[system];
      for (let n = min * 2; n <= max * 2; n++) values.add(n / 2);
    });
    return [...values].sort((a, b) => a - b);
  }
  function matches(rows, system, value) {
    if ((system !== 'men' && system !== 'women') || typeof value !== 'string' || !/^\d+(?:\.5)?$/.test(value)) return [];
    const size = Number(value);
    return rows.filter(row => size >= row[system][0] && size <= row[system][1]);
  }
  window.PXSizeGuide = Object.freeze({ range, readRows, choices, matches });
  const finder = document.getElementById('size-finder');
  const rows = readRows(window.PX_DATA);
  if (!finder || rows.length !== 5) return;
  const system = document.getElementById('sg-system');
  const input = document.getElementById('sg-shoe-size');
  const label = document.getElementById('sg-result-label');
  const sizeText = document.getElementById('sg-result-size');
  const copy = document.getElementById('sg-result-copy');
  const link = document.getElementById('sg-result-link');
  if (![system, input, label, sizeText, copy, link].every(Boolean)) return;
  const tableRows = [...document.querySelectorAll('[data-size-row]')];
  // Keep the readable no-JS chart in sync with the same source used by the helper.
  tableRows.forEach(el => {
    const row = rows.find(item => item.size === el.dataset.sizeRow);
    const cells = el.querySelectorAll('td');
    if (!row || cells.length !== 3) return;
    cells[0].textContent = row.menLabel; cells[1].textContent = row.womenLabel;
    cells[2].replaceChildren(document.createTextNode(`${row.lengthIn.toFixed(2)} in `));
    const cm = document.createElement('span'); cm.textContent = `${row.lengthCm.toFixed(1)} cm`; cells[2].append(cm);
  });
  function setLink(text, href) {
    link.replaceChildren(document.createTextNode(`${text} `));
    const arrow = document.createElement('span'); arrow.setAttribute('aria-hidden','true'); arrow.textContent = '↗';
    link.append(arrow); link.setAttribute('href', href);
  }
  function update() {
    const found = matches(rows, system.value, input.value);
    tableRows.forEach(row => row.classList.toggle('is-match', found.some(item => item.size === row.dataset.sizeRow)));
    label.textContent = 'Your PerseveranX size';
    if (!input.value) {
      sizeText.textContent = 'Choose above'; copy.textContent = 'Your matching size will appear here.';
      setLink('View the full chart', '#sizes'); return;
    }
    if (!found.length) {
      label.textContent = 'A little help choosing'; sizeText.textContent = 'Let’s check';
      copy.textContent = 'If your size isn’t listed, ask us before sizing up or trimming a larger pair. Send your usual size and shoe model.';
      setLink('Ask about your size', 'mailto:perseveranx@gmail.com?subject=Help%20choosing%20an%20insole%20size'); return;
    }
    sizeText.textContent = found.map(row => row.size).join(' or ');
    const lengths = found.map(row => `${row.size}: ${row.lengthIn.toFixed(2)} in (${row.lengthCm.toFixed(1)} cm)`).join(' · ');
    if (found.length > 1) {
      label.textContent = 'Two sizes share this boundary';
      copy.textContent = `${lengths}. Compare your original removable insole with both lengths, then check the shape and room in your shoe.`;
      setLink('Compare the lengths', '#lengths');
    } else {
      copy.textContent = `${lengths} before trimming. Use this as your starting size, then check arch position, heel seating and toe room in your shoe.`;
      setLink('Check the fit in your shoe', '#shoe-fit');
    }
  }
  function resetOptions() {
    const placeholder = document.createElement('option'); placeholder.value = ''; placeholder.textContent = 'Select size';
    input.replaceChildren(placeholder);
    choices(rows, system.value).forEach(value => {
      const option = document.createElement('option'); option.value = String(value); option.textContent = String(value); input.append(option);
    });
    const other = document.createElement('option'); other.value = 'not-listed'; other.textContent = 'My size isn’t listed'; input.append(other);
    input.value = ''; update();
  }
  system.addEventListener('change', resetOptions);
  input.addEventListener('change', update);
  resetOptions(); finder.hidden = false;
})();
